import styles from './summary-details-old.module.scss';
import { ISummaryPageSettings } from '../../../models/summary/ISummaryPageSettings';
import { ISummaryData } from '../../../models/summary/ISummaryData';
import { ISummaryContent } from '../../../models/summary/ISummaryContent';
import { ISummaryCourse } from '../../../models/summary/ISummaryCourse';
import SummaryDegreeListOld from '../summary-degree-list-old/summary-degree-list-old';

export type Props = {
  summaryPageSettings: ISummaryPageSettings;
  summaryData: ISummaryData[];
  summaryContent: ISummaryContent;
  googleTagId?: string;
  courseList?: ISummaryCourse[];
  application: string;
};

export default function SummaryDetailsOld({
  summaryPageSettings,
  summaryData,
  summaryContent,
  googleTagId,
  courseList,
  application,
}: Props) {
  let degrees: ISummaryData[] = [];
  const programLevel =
    summaryContent?.summaryPageType?.fields?.level == `Postgraduate` ? `Graduate` : `Undergraduate`;

  if (summaryContent?.summaryPageType?.fields?.programGroupName) {
    degrees = summaryData.filter(
      (a) => a.programGroup === summaryContent?.summaryPageType?.fields?.programGroupName,
    );
  } else {
    degrees = summaryData.filter(
      (a) =>
        // a.route === summaryContent?.summaryPageType?.fields?.entryRoute &&
        a.level === programLevel,
    );
  }

  return (
    <div className={styles[`summary-details`]}>
      <div className={styles[`summary-title`]}>
        <h2 id='summary-details'>Degrees</h2>
        {!!degrees && degrees.length > 0 && (
          <SummaryDegreeListOld
            degrees={degrees}
            pagingLimit={10}
            summaryPageSettings={summaryPageSettings}
            brandName={summaryContent.brand.fields.brandName}
            googleTagId={googleTagId}
            courseList={courseList}
            application={application}
          />
        )}
      </div>
    </div>
  );
}
